export default function Contact() {
	return (
		<section className="container-gg py-12">
			<h1 className="text-3xl font-bold text-slate-900">Contact Us</h1>
			<p className="mt-4 max-w-2xl text-slate-700">We'd love to hear from you. Reach us via email, phone, or visit our campus.</p>
			<div className="mt-8 grid gap-6 md:grid-cols-2">
				<div className="rounded-lg border border-slate-200 p-6">
					<p className="font-semibold">Email</p>
					<p className="mt-2 text-slate-700">greatgraceinternationalchristi@gmail.com</p>
					<p className="mt-4 font-semibold">Phone</p>
					<p className="mt-2 text-slate-700">+234-915 890 0059</p>
				</div>
				<div className="rounded-lg border border-slate-200 p-6">
					<p className="font-semibold">Address</p>
					<p className="mt-2 text-slate-700">Main Campus, GreatGrace Avenue, City, Country.</p>
					<p className="mt-4 text-sm text-slate-600">School Hours: Mon-Fri, 8:00am - 4:00pm</p>
				</div>
			</div>
		</section>
	)
}







